import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Local Selectors
// @ts-ignore
import { selectOptions } from './selectors';

type ChildrenFunction = (values: any) => React.ReactElement;
interface OwnProps {
    children: React.ReactElement | ChildrenFunction;
}

interface ConnectedProps {
    options: {
        id: number;
        text: string;
        name: string;
    }[];
}

type Props = OwnProps & ConnectedProps;

export class VarietyOptionsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { options, children } = this.props;

        if (typeof children === 'function') {
            return children(options);
        }

        // @ts-ignore
        return React.cloneElement(children, { options });
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: selectOptions
});

export default connect(mapStateToProps)(VarietyOptionsComponent);
